export const COOKIE_NAME = "app_session_id";
export const STANDARD_SESSION_MAX_AGE_MS = 1000 * 60 * 60 * 24; // 24 hours
export const REMEMBER_ME_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 7; // 7 days
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';
